import merge from 'lodash/merge';
import * as types from '../actions/actionTypes';
import Analytics from './../analytics';
import {UserPopupTypes, ConfirmPopupTypes, UserPopupContent} from "../bvcomponents/visComponents/constants";
import {parseQuery} from "../misc/helpers";
import {
  parseFabricatorSettings
} from "./fabricatorReducer";
import {PREFERRED_COMMUNICATION_METHODS} from "../bvcomponents/popups/assignQuotePopup/assignQuoteConstants";
import Config from "../config";
import {hardCodeIsCaesarStone, hardCodeIsGraniteTransformationUK, hardCodeIsLowes} from "../misc/fabricatorHardcode";

const dashboardFramed = Config.isVisualizerManagement();
const parsedUrl = parseQuery();

export const countries = {
  "GBP": {
    name: "United Kingdom",
    iso2: "gb",
    dialCode: "44",
    priority: 0,
    areaCodes: null,
  },
  "USD": {
    areaCodes: null,
    dialCode: "1",
    iso2: "us",
    name: "United States",
    priority: 0
  },
  "CAD": {
    areaCodes: null,
    dialCode: "1",
    iso2: "ca",
    name: "Canada",
    priority: 1
  },
  "AUS": {
    areaCodes: null,
    dialCode: "61",
    iso2: "au",
    name: "Australia",
    priority: 0
  },
  "PAB": {
    areaCodes: null,
    dialCode: "507",
    iso2: "pa",
    name: "Panama",
    priority: 0
  },
  "SPN": {
    areaCodes: null,
    dialCode: "37",
    iso2: "es",
    name: "Spain",
    priority: 0
  },
  "PLN": {
    name: "Poland (Polska)",
    iso2: "pl",
    dialCode: "48",
    priority: 0,
    areaCodes: null,
  },
};

export const getDefaultCountry = (fabricatorSettings) => {
  if (fabricatorSettings.currency === "GBP" || hardCodeIsGraniteTransformationUK()) {
    return countries.GBP
  } if (fabricatorSettings.currency === "PLN") {
    return countries.PLN
  } else if (hardCodeIsLowes()) {
    return countries.CAD
  }
  // const {intl} = this.props;
  // if (intl.locale === "en-AU" || this.props.fabricatorData.isCaesarStone) {
  // if (fabricatorState.isCaesarStone) {
  //   return countries.AUS
  // }
  const currency = fabricatorSettings.currency === "AUD" ? "AUS" : fabricatorSettings.currency;
  return countries[currency] || countries.USD
};

const initialState = {
  userPopupOpened: false,
  userPopupType: UserPopupTypes.Unlock,
  saveQuoteAfterLogin: false,
  userIsLoggedIn: dashboardFramed,
  userSchedulerOpened: false,
  checkout: false,
  userInfo: {
    phone: "",
    email: "",
    password: "",
    firstName: "",
    phoneNumber: "",
    postal: "",
    salesPersonEmail: (window.salesPerson ? window.salesPerson.email : ""),
    salesPersonFullName: (window.salesPerson ? window.salesPerson.name : ""),
    isNew: true,
    fabricatorId: document.kvConfig.userId || 61986,
    employeeId: window.salesPerson
      ? window.salesPerson.rawVal / ( Math.floor(Math.PI * 1000))
      : (parsedUrl && parsedUrl.p) ? +parsedUrl.p.split("/")[0] : "",
    lastName: "",
    phone2: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    preferredCommunicationMethod: "", // (I assume it will be constants - email or phone)
    howDidYouHearAboutUs: "", // (probably constants too, it is a select in the design)
    country: countries.USD, // should be set as an object! from Countries list
    provence: "", // can be received from getCustomerById response
    shipping: {}, // address can be received from getCustomerById response
    agreedToTerms: false,
    subscribeToNewsletter: true,
  },
  editToken: ((parsedUrl && parsedUrl.edittoken) ? parsedUrl.edittoken : null),
  userInfoErrors: {},  // {"fullName": ["too short"]}, {"phoneNumber": ["this field is required"]}, etc.
  showAdditionalFields: false,
  employeesList: [],
  employeesListReceived: false,
  isPhoneNumberValidated: dashboardFramed,
  // clickLeadCapture: false,
  confirmPopupOpened: false,
  confirmPopupType: ConfirmPopupTypes.ConsultationRequest,
  confirmPopupTag: {}, // object - is used for passing data in the confirm popup
  showPrivacyPolicy: false,
  alreadyRegisteredUserInfo: {
    //... other fields from userLogin response
    userId: "", // custom field // this will be passed in register response
    assignQuote: false, // custom field // if it was clicked from assign quote popup
    withCheckoutLogic: false, // custom field // if it was clicked from assign quote popup and with checkout logic
    confirmedAssign: false // custom field // if it was confirmed from user (he wants to assign quote on already registered user) - is changing in confirm popup
  },
  userPopupContent: UserPopupContent.register,
  leadCaptureClickCount: 0,
  userTwoFa: {
    twoFALoading: false,
    twoFAToken: "",
  },
  optIn: false
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.TOGGLE_USER_POPUP:
      Analytics.sendEvent("user-popup", action.payload.userPopupOpened ? "Opened" : "Closed");
      return {
        ...merge(state, action.payload), // deep merge, otherwise userInfo gets overwritten.
        userPopupType: action.payload.userPopupType || UserPopupTypes.Unlock,
        saveQuoteAfterLogin: action.payload.saveQuoteAfterLogin || false,
        checkout: typeof(action.payload.checkout) === 'undefined' ? state.checkout : action.payload.checkout
      };
    case types.TOGGLE_ADDITIONAL_FIELDS:
    case types.TOGGLE_CONFIRM_POPUP:
    case types.SET_USER_POPUP_CONTENT:
    case types.SET_LEAD_CAPTURE_CLICK_COUNT:
    case types.SET_USER_OPT_IN:
      return {...state, ...action.payload};
    case types.SET_ALREADY_REGISTERED_USER:
      return {...state, alreadyRegisteredUserInfo: {...state.alreadyRegisteredUserInfo, ...action.payload.alreadyRegisteredUserInfo}};
    case types.CHANGE_USER_INFO: {
      let {userInfo} = state;
      userInfo = {...userInfo, ...action.payload.userInfo};
      return {...state, userInfo};
    }
    case types.CHANGE_USER_INFO_ERRORS: {
      let {userInfoErrors} = state;
      userInfoErrors = {...userInfoErrors, ...action.payload.userInfoErrors};
      return {...state, userInfoErrors};
    }
    case types.SET_USER_TWO_FA: {
      let {userTwoFa} = state;
      userTwoFa = {...userTwoFa, ...action.payload.userTwoFa};
      return {...state, userTwoFa};
    }
    case types.SET_EMPLOYEES_LIST:
      // console.log('action.payload', action.payload);
      return Object.assign({}, state, action.payload, {employeesListReceived: true});
    case types.SET_USER_PHONE_NUMBER_VALIDATED:
      return {...state, isPhoneNumberValidated: action.payload.isPhoneNumberValidated};
    case types.RESTORE_USER_STATE:
      if (action.payload.userInfo) {
        if (!action.payload.userInfo.country || !action.payload.userInfo.country.dialCode) {
          action.payload.userInfo.country = state.userInfo.country
        }
        if (action.payload.userInfo.firstName === "N/A") {
          action.payload.userInfo.firstName = "";
        }
        if (action.payload.userInfo.lastName === "N/A") {
          action.payload.userInfo.lastName = "";
        }
      }
      return {
        ...state,
        ...action.payload,
        userPopupOpened: false,
        userPopup2FAOpened: false,
        confirmPopupOpened: false,
        userIsLoggedIn: true,
      };
    case types.SHOW_SCHEDULER:
      action.payload.show
        ? document.body.classList.add("body--shedule")
        : document.body.classList.remove("body--shedule");
      return {...state, userSchedulerOpened: action.payload.show};
    case types.SET_FABRICATOR_DATA: {
      const userInfo = {...state.userInfo};
      const {settings} = parseFabricatorSettings(action.payload);
      userInfo.country = getDefaultCountry(settings);
      if (hardCodeIsCaesarStone() && settings.currency === "USD") {
        userInfo.preferredCommunicationMethod = PREFERRED_COMMUNICATION_METHODS[0]
      }
      return {...state, userInfo};
    }
  }
  return state;
}
